import request from '../untils/request';

export const showListApi = params => {
  return request({
    url: '/goods/goods-basic/show-list',
    params,
  });
};


export const getAuthListApi = params => {
  return request({
    url: '/member/member-sub/get-all-purview',
    params,
  });
};


export const operationArchiveSelectListApi = params => {
  return request({
    url: '/operation/archive/type',
    params,
  });
};